"use strict";

CompanyDeviationWatcherService.$inject = ['config', '$resource'];
function CompanyDeviationWatcherService(config, $resource) {
  return $resource(config.apiBase + '/companies/:companyId/deviation-watchers/:deviationWatcherId' , {}, {
    "update": {
      method: 'PUT'
    },
  });
}

angular.module('dokiv')
  .factory('CompanyDeviationWatcherService', CompanyDeviationWatcherService);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/deviation-watchers/CompanyDeviationWatcherService.js
// module id = 39
// module chunks = 0